export let attendanceArray = [
  {
    id: 0,
    name: "Go Pro Company",
    location: "Lagos, Nigeria",
    date: "12 JUNE",
    title: `Future of Web3 Conference'`,
    price: "$8.00",
    image: "/images/event1.png",
    mapline: "/images/MapPinLine.svg",
    icon: "/images/userorganizer1.png",
  },

  {
    id: 1,
    name: "Dennis Andrew",
    location: "Lagos, Nigeria",
    date: "21 JUNE",
    title: "Kuramo- All White Beach",
    price: "FREE",
    image: "/images/event2.png",
    mapline: "/images/MapPinLine.svg",
    icon: "/images/userorganizer3.png",
  },

  {
    id: 2,
    name: "Hertechtrail",
    location: "Lagos, Nigeria",
    date: "29 JUNE",
    title: "Women and Tech Careers",
    price: "FREE",
    image: "/images/event3.png",
    mapline: "/images/MapPinLine.svg",
    icon: "/images/userorganizer2.png",
  },
];

export let remainEvents = [
  {
    id: 0,
    heading: "Sport Events",
    name: "Wallace James",
    location: "Lagos",
    date: "03 JUNE",
    title: "Goalfest 2023",
    price: "$10.00",
    image: "/images/event_image2.svg",
    mapline: "/images/MapPinLine.svg",
    icon: "/images/eventcreator_3.svg",
  },
  {
    id: 1,
    name: "Thomson Junior",
    location: "Lagos",
    date: "13 JUNE",
    title: "Painting Trainings",
    image: "/images/event_image3.svg",
    price: "FREE",
    mapline: "/images/MapPinLine.svg",
    icon: "/images/eventcreator_3.svg",
  },
];
